import {useRouter} from "vue-router";

export function usePrevious(){
    const router = useRouter()
    function $previous(){
        router.go(-1)
    }

    return {$previous}
}